import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

/**
 * Create transaction DTO
 */
export class CreateTransactionDto {
  color?: string | null;
  description?: string | null;
  externalReference?: string | null;
  notes?: string | null;
  recordCategory!: TransactionRecordCategoryEnum;
  type!: TransactionTypeEnum;
  @TransformInt()
  locationId?: number | null;
  @TransformInt()
  customerId?: number | null;
  @TransformInt()
  supplierId?: number | null;
  @TransformInt()
  agentId?: number | null;
  @TransformInt()
  vehicleId?: number | null;
  @TransformInt()
  rentalAgreementId?: number | null;
  @TransformInt()
  rentalReservationId?: number | null;
  @TransformInt()
  vehicleRoadTaxId?: number | null;
  @TransformInt()
  vehicleInsuranceId?: number | null;
  @TransformInt()
  vehicleRoadWorthyCheckId?: number | null;
  @TransformInt()
  vehicleMaintenanceId?: number | null;
  taxRateType?: TaxRateTypeEnum | null;
  @TransformFloat()
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  @TransformFloat()
  amount?: number | null;
  @TransformFloat()
  totalNet?: number | null;
  @TransformFloat()
  totalTax?: number | null;
  @TransformFloat()
  totalGross?: number | null;
  tags?: TagDto[] | null;
  files?: FileDto[] | null;
}
